import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from 'react-router-dom'
import { actions } from '../../../redux/modules/reports/general/activityReportActions'
import { DatePicker, Button } from 'antd'
import moment from 'moment'
import _ from 'lodash'
import OverviewByUser from '../../../components/reports/general/activity-report/OverviewByUser'
import Overview from '../../../components/reports/general/activity-report/Overview'
import ContactsAdded from '../../../components/reports/general/activity-report/ContactsAdded'
import CompaniesAdded from '../../../components/reports/general/activity-report/CompaniesAdded'
import LeadsAdded from '../../../components/reports/general/activity-report/LeadsAdded'
import JobsAdded from '../../../components/reports/general/activity-report/JobsAdded'
import EstimatesAdded from '../../../components/reports/general/activity-report/EstimatesAdded'

import queryString from 'qs'
import config from '../../../config'

const { API_BASE } = config

const { RangePicker } = DatePicker

const propTypes = {}

class ActivityReportContainer extends Component {
  constructor(props) {
    super(props)
    const filter = [
      moment(new Date(), 'YYYY-MM-DD').startOf('month'),
      moment(new Date(), 'YYYY-MM-DD').endOf('month')
    ]
    const serviceParams = {
      startDate: moment(filter[0]).format('YYYY-MM-DD'),
      endDate: moment(filter[1]).format('YYYY-MM-DD')
    }
    this.state = {
      filter: filter
    }

    this.props.activityReportGetOverview({
      filters: serviceParams
    })

    this.props.activityReportGetOverviewByUser({
      filters: serviceParams
    })

    this.props.activityReportGetContactsAdded({
      filters: serviceParams
    })

    this.props.activityReportGetCompaniesAdded({
      filters: serviceParams
    })

    this.props.activityReportGetLeadsAdded({
      filters: serviceParams
    })

    this.props.activityReportGetJobsAdded({
      filters: serviceParams
    })

    this.props.activityReportGetEstimatesAdded({
      filters: serviceParams
    })
  }

  onChange = (date, dateString) => {
    this.setState({
      filter: dateString
    })
  }

  applyFilter = () => {
    const { filter } = this.state
    const filterParam = {
      startDate: filter[0],
      endDate: filter[1]
    }
    this.props.activityReportGetOverview({
      filters: filterParam
    })

    this.props.activityReportGetOverviewByUser({
      filters: filterParam
    })

    this.props.activityReportGetContactsAdded({
      filters: filterParam
    })

    this.props.activityReportGetCompaniesAdded({
      filters: filterParam
    })

    this.props.activityReportGetLeadsAdded({
      filters: filterParam
    })

    this.props.activityReportGetJobsAdded({
      filters: filterParam
    })

    this.props.activityReportGetEstimatesAdded({
      filters: filterParam
    })
  }

  printReport = () => {
    const { filter } = this.state
    const params = {
      startDate: typeof filter[0] === 'string' ? filter[0] : filter[0].format('YYYY-MM-DD'),
      endDate: typeof filter[1] === 'string' ? filter[1] : filter[1].format('YYYY-MM-DD')
    }
    const qs = queryString.stringify(params)
    const url = `${API_BASE}/api/reports/general/activity-report/print?${qs}`
    window.open(url, '_blank')
  }

  render() {
    const overviewData = _.get(this.props, 'activityReportActions.overview.data')
    const loadingOverview = _.get(this.props, 'activityReportActions.loadingOverview')

    const overviewByUserData = _.get(this.props, 'activityReportActions.overviewByUser.data')
    const loadingOverviewByUser = _.get(this.props, 'activityReportActions.loadingOverviewByUser')

    const contactsAddedData = _.get(this.props, 'activityReportActions.contactsAdded.data')
    const loadingContactsAdded = _.get(this.props, 'activityReportActions.loadingContactsAdded')

    const companiesAddedData = _.get(this.props, 'activityReportActions.companiesAdded.data')
    const loadingCompaniesAdded = _.get(this.props, 'activityReportActions.loadingCompaniesAdded')

    const leadsAddedData = _.get(this.props, 'activityReportActions.leadsAdded.data')
    const loadingLeadsAdded = _.get(this.props, 'activityReportActions.loadingLeadsAdded')

    const jobsAddedData = _.get(this.props, 'activityReportActions.jobsAdded.data')
    const loadingJobsAdded = _.get(this.props, 'activityReportActions.loadingJobsAdded')

    const estimatesAddedData = _.get(this.props, 'activityReportActions.estimatesAdded.data')
    const loadingEstimatesAdded = _.get(this.props, 'activityReportActions.loadingEstimatesAdded')
    return (
      <div style={{ marginTop: 20, marginBottom: 20 }}>
        <div className="row">
          <div className="col-10">
            <h3>Activity Report</h3>
          </div>
          <Button icon="printer" onClick={() => this.printReport()} />
        </div>
        <div className="row">
          <div className="col-12">
            Select the date range:<br />
            <RangePicker
              defaultValue={[
                moment(new Date(), 'YYYY-MM-DD').startOf('month'),
                moment(new Date(), 'YYYY-MM-DD').endOf('month')
              ]}
              onChange={this.onChange}
            />
            <br />
            <br />
            <Button type="primary" onClick={() => this.applyFilter()}>
              Submit
            </Button>
          </div>
        </div>
        <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
          <div className="col-4">
            <h4>Overview</h4>
            <Overview overviewData={overviewData} loadingOverview={loadingOverview} />
          </div>
          <div className="col-8">
            <h4>Overview by User</h4>
            <OverviewByUser
              overviewByUserData={overviewByUserData}
              loadingOverviewByUser={loadingOverviewByUser}
            />
          </div>
        </div>
        <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
          <div className="col-12">
            <h4>Contacts Added</h4>
            <ContactsAdded
              contactsAddedData={contactsAddedData}
              loadingContactsAdded={loadingContactsAdded}
            />
          </div>
        </div>
        <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
          <div className="col-12">
            <h4>Companies Added</h4>
            <CompaniesAdded
              companiesAddedData={companiesAddedData}
              loadingCompaniesAdded={loadingCompaniesAdded}
            />
          </div>
        </div>
        <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
          <div className="col-12">
            <h4>Leads Added</h4>
            <LeadsAdded leadsAddedData={leadsAddedData} loadingLeadsAdded={loadingLeadsAdded} />
          </div>
        </div>
        <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
          <div className="col-12">
            <h4>Jobs Added</h4>
            <JobsAdded jobsAddedData={jobsAddedData} loadingJobsAdded={loadingJobsAdded} />
          </div>
        </div>
        <div className="row" style={{ marginTop: 20, marginBottom: 20 }}>
          <div className="col-12">
            <h4>Estimates Added</h4>
            <EstimatesAdded
              estimatesAddedData={estimatesAddedData}
              loadingEstimatesAdded={loadingEstimatesAdded}
            />
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = ({ activityReportActions, authentication }, ownProps) => ({
  activityReportActions,
  authentication
})
const mapDispatchToProps = (dispatch, ownProps) => ({
  ...bindActionCreators(Object.assign({}, actions), dispatch)
})

ActivityReportContainer.propTypes = propTypes
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ActivityReportContainer))



// WEBPACK FOOTER //
// ./src/containers/reports/general/ActivityReportContainer.js